module.exports = "/_next/static/images/8888e5afb2445fae30aea962deaa5842-man-looking-up-smiling-md@1x.jpg.webp";